import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineDescriptionList のスタイル
 */
export const hotlineDescriptionListStyle = tv({
    slots: {
        base: ['flex flex-col gap-20'],
        item: ['flex flex-col lg:flex-row gap-8 lg:gap-16'],
        itemTitle: [
            textStyle({ color: 'base', isBold: true, size: 'sm' }),
            'break-all',
            'lg:shrink-0',
            'lg:w-[120px]',
        ],
        itemValue: [
            textStyle({ color: 'base', size: 'sm' }),
            'lg:grow',
            'break-all whitespace-pre-line',
        ],
    },
});
